<script setup lang="ts">
import { ref, onMounted } from "vue";

const now_time = ref("");

function updateTime() {
  now_time.value = new Date().toLocaleString();
}

onMounted(() => {
  updateTime();
  setInterval(() => {
    updateTime();
  }, 1000);
});
</script>

<template>
  <div class="footer">
    <div class="footer-left">
      <p class="foot-time">{{ now_time }}</p>
    </div>

    <div class="footer-center">
      <a href="https://beian.miit.gov.cn/" target="_blank">
        <t-button theme="default" variant="outline" :ghost="true">豫ICP备15024677号-4</t-button>
      </a>
    </div>

    <div class="footer-right">
      <p class="foot-text">
        <a href="https://www.didapipa.com" target="_blank">
          <t-button theme="default" variant="outline" :ghost="true">@DiDaPiPa</t-button>
        </a>
      </p>
    </div>
  </div>
</template>

<style scoped>
.footer {
  margin-top: 30px;
  display: flex;
  color: #ffffff;
  background-color: #000000;
  justify-content: space-between;
  align-items: center;
  padding-left: 24px;
  padding-right: 24px;
  height: 80px;
}

.footer-left {
  display: flex;
  justify-content: flex-start;
  flex-grow: 1;
}

.footer-center {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
}

.footer-right {
  display: flex;
  justify-content: flex-end;
  flex-grow: 1;
}
</style>
